import { render, staticRenderFns } from "./IcTrue.vue?vue&type=template&id=9b0b7624&scoped=true"
import script from "./IcTrue.vue?vue&type=script&lang=js"
export * from "./IcTrue.vue?vue&type=script&lang=js"
import style0 from "./IcTrue.vue?vue&type=style&index=0&id=9b0b7624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0b7624",
  null
  
)

export default component.exports